module.exports = __webpack_public_path__ + "img/news02.0d996a5.png";